<template>
  <div>
    <h3 class="co-heading-3">
      お得なプランってどれ？
    </h3>
    <p class="mb-4">
      <span class="inline text-left md:block md:text-center">
        受講料をトータルのチャットサポート時間で割った1時間あたりの料金で比較。
      </span>
      <span class="inline text-left md:block md:text-center">
        期間が長いプランほど1時間あたりの料金は安くなります。
      </span>
    </p>

    <div
      :class="['mb-[3.25rem] flex flex-col items-center justify-center gap-10 lg:mx-3 lg:flex-row lg:gap-6', is4WeeksPlan ? '' : 'co-container-sm']"
    >
      <!-- 4週間プラン -->
      <div
        v-if="is4WeeksPlan"
        class="te-price-card border border-[rgba(0,0,0,0.13)] bg-white lg:grow"
      >
        <div class="co-display-10 border-b border-[rgba(0,0,0,.125)] bg-co-info-500 px-5 py-3 text-center text-white">
          4週間プラン
        </div>
        <div class="te-week-4 relative p-5 text-center">
          <p class="mb-0">
            <template v-if="isStudent">
              社会人
            </template> {{ $addComma(social4WeeksPlan.price_for_1hour) }}円
            <br>
            <template v-if="isStudent">
              学生 {{ $addComma(student4WeeksPlan.price_for_1hour) }}円
            </template>
          </p>
          <div class="te-arrow">
            よりお得
          </div>
        </div>
      </div>
      <!-- 8週間プラン -->
      <div class="te-price-card border border-[rgba(0,0,0,0.13)] bg-white lg:grow">
        <div class="co-display-10 border-b border-[rgba(0,0,0,.125)] bg-co-success-500 px-5 py-3 text-center text-white">
          8週間プラン
        </div>
        <div class="te-week-8 relative p-5 text-center">
          <p class="mb-0">
            <template v-if="isStudent">
              社会人
            </template> {{ $addComma(social8WeeksPlan.price_for_1hour) }}円
            <br>
            <template v-if="isStudent">
              学生 {{ $addComma(student8WeeksPlan.price_for_1hour) }}円
            </template>
          </p>
          <div class="te-arrow">
            さらにお得
          </div>
        </div>
      </div>
      <!-- 12週間プラン -->
      <div class="te-price-card border border-[rgba(0,0,0,0.13)] bg-white lg:grow">
        <div class="co-display-10 border-b border-[rgba(0,0,0,.125)] bg-co-warning-500 px-5 py-3 text-center text-white">
          12週間プラン
        </div>
        <div class="te-week-12 relative p-5 text-center">
          <p class="mb-0">
            <template v-if="isStudent">
              社会人
            </template> {{ $addComma(social12WeeksPlan.price_for_1hour) }}円
            <br>
            <template v-if="isStudent">
              学生 {{ $addComma(student12WeeksPlan.price_for_1hour) }}円
            </template>
          </p>
          <div class="te-arrow">
            もっとお得
          </div>
        </div>
      </div>
      <!-- 16週間プラン -->
      <div class="te-price-card border border-[rgba(0,0,0,0.13)] bg-white lg:grow">
        <div class="co-display-10 border-b border-[rgba(0,0,0,.125)] bg-[#625fb7] px-5 py-3 text-center text-white">
          16週間プラン
        </div>
        <div class="relative p-5 text-center">
          <p class="mb-0">
            <template v-if="isStudent">
              社会人
            </template> {{ $addComma(social16WeeksPlan.price_for_1hour) }}円
            <br>
            <template v-if="isStudent">
              学生 {{ $addComma(student16WeeksPlan.price_for_1hour) }}円
            </template>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

const options = {
  props: {
    course: {
      type: Object,
    },
    is4WeeksPlan: {
      type: Boolean,
      default: true,
    },
    isStudent: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    plans(): any {
      return this.course ? this.course.attributes.plans : null
    },
    social4WeeksPlan(): object {
      return this.plans ? this.plans.social_4weeks : { price_for_1hour: '-' }
    },
    social8WeeksPlan(): object {
      return this.plans ? this.plans.social_8weeks : { price_for_1hour: '-' }
    },
    social12WeeksPlan(): object {
      return this.plans ? this.plans.social_12weeks : { price_for_1hour: '-' }
    },
    social16WeeksPlan(): object {
      return this.plans ? this.plans.social_16weeks : { price_for_1hour: '-' }
    },
    student4WeeksPlan(): object {
      return this.plans ? this.plans.student_4weeks : { price_for_1hour: '-' }
    },
    student8WeeksPlan(): object {
      return this.plans ? this.plans.student_8weeks : { price_for_1hour: '-' }
    },
    student12WeeksPlan(): object {
      return this.plans ? this.plans.student_12weeks : { price_for_1hour: '-' }
    },
    student16WeeksPlan(): object {
      return this.plans ? this.plans.student_16weeks : { price_for_1hour: '-' }
    },
  },
  filters: {
    addComma(value: number) {
      return value ? value.toLocaleString() : '-'
    },
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-price-card {
  @media (max-width: 991.98px) {
    width: 50%;
  }
  @media (max-width: 575.98px) {
    width: 100%;
  }
}

/* 矢印 */
.te-arrow {
  position: absolute;
  right: 0;
  bottom: -1.25rem;
  left: 0;
  z-index: 2;
  display: block;
  width: 6.25rem;
  height: 1.875rem;
  padding: .25rem;
  margin: auto;
  font-size: 0.875rem;
  color: #333;
  text-align: center;
  background-color: #ccc;
  @media (min-width: 992px) {
    top: 50%;
    right: -3.125rem;
    left: auto;
    width: 5.125rem;
    height: 1.75rem;
    padding: 0.125rem 0.125rem 0.125rem 0.625rem;
    margin-top: -1rem;
    text-align: left;
  }
  &::after {
    position: absolute;
    top: 1.875rem;
    left: 3.125rem;
    content: '';
    border: 80px solid transparent;
    border-top: 35px solid #ccc;
    transform: translate(-50%, 0);
    @media (min-width: 992px) {
      top: -0.4375rem;
      left: 5.125rem;
      border: 20px solid transparent;
      border-left: 20px solid #ccc;
      transform: unset;
    }
  }
}

</style>
